import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import ReactTableBase from 'src/shared/components/table/ReactTableBase';
import { Card, CardBody } from 'reactstrap';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { Typography } from '@mui/material';

const OrderApprovalView = ({ reactTableData, isNoRecordFound, isTotalCount, isPageSize, isTotalPages, onRowClick }) => {
    const [rows, setRows] = useState([]);
    const { t } = useTranslation('common');

    useEffect(() => {
        if (reactTableData && reactTableData.tableRowsData) {
            setRows(reactTableData.tableRowsData);
        } else {
            setRows([]);
        }
    }, [reactTableData]);


    const tableConfig = {
        isEditable: false,
        isSortable: true,
        isResizable: false, // Disabling resizable for responsive table fit
        withPagination: true,
        withSearchEngine: true,
        className: 'table--security-approval', // Applying custom style
        manualPageSize: [10, 50, 100, 1000],
        placeholder: 'Search by Order No., Hybris Order No., etc',
        // Assuming ReactTableBase uses `getTrProps` or similar from react-table or custom prop for row click
        // If ReactTableBase doesn't support onRowClick directly, we might need to modify it or use a custom cell to trigger selection.
        // For now, let's pass it as a prop to ReactTableBase if it supports it.
    };

    if (isNoRecordFound || !rows || rows.length === 0) {
        return (
            <Card className="shadow-sm border-0">
                <CardBody className="d-flex flex-column align-items-center justify-content-center py-5">
                    <SentimentDissatisfiedIcon sx={{ fontSize: 60, color: '#9e9e9e', mb: 2 }} />
                    <Typography variant="h6" color="textSecondary" gutterBottom>
                        No Records Found
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        There are no orders to display at the moment.
                    </Typography>
                </CardBody>
            </Card>
        );
    }

    return (
        <div className="order-approval-table-container">
            <ReactTableBase
                name="Order Approval List"
                key={'searchable'}
                columns={reactTableData.tableHeaderData}
                data={rows}
                tableConfig={tableConfig}
                isTotalCount={isTotalCount}
                isPageSize={isPageSize}
                isTotalPages={isTotalPages}
                onRowClick={onRowClick}
            />
        </div>
    );
};

OrderApprovalView.propTypes = {
    reactTableData: PropTypes.shape({
        tableHeaderData: PropTypes.arrayOf(PropTypes.shape({
            key: PropTypes.string,
            name: PropTypes.string,
        })),
        tableRowsData: PropTypes.arrayOf(PropTypes.shape()),
    }),
    isNoRecordFound: PropTypes.bool,
};

export default OrderApprovalView;
